import { useState } from "react";
import { Link } from "react-router-dom";
import { FAQ_ITEMS } from "@/mocks/faq";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 grid gap-10 lg:gap-16 lg:grid-cols-[0.8fr_1.4fr]">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600 uppercase">
            <span className="h-px w-8 bg-primary-400" /> FAQ
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题解答
          </h2>
          <p className="mt-4 max-w-sm text-sm md:text-base leading-7 text-foreground-600">
            关于档案库的性质、检索方式与纠错渠道，一次说清。还有疑问，随时通过投稿表单联系我们。
          </p>
          <Link
            to="/about#submit"
            className="mt-6 inline-flex items-center gap-1.5 rounded-full border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            联系编辑团队 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="rounded-xl border border-background-300/70 bg-background-50 overflow-hidden">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-center gap-3 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className={`shrink-0 grid place-items-center w-7 h-7 rounded-lg text-xs font-semibold ${isOpen ? "bg-primary-600 text-background-50" : "bg-primary-100 text-primary-700"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-medium text-sm md:text-base text-foreground-900">{item.q}</span>
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-lg text-foreground-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                  </button>
                </h3>
                <div className={`grid transition-[grid-template-rows] duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 pl-[3.25rem] text-sm leading-7 text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}